import React, { useState, useContext } from 'react';
import { Dropdown } from 'react-bootstrap';
import AddMenu from './AddMenu';
import AddToggle from './AddToggle';
import DealContext from './DealContext';

const AddTab = ({ hasCustomer, hasQuotes, showCustomer, viewingQuote }) => {
  const [addToggleOpen, setAddToggleOpen] = useState(false);
  const { presentCustomer, handleNewQuote, handleNewNote, handleCopyQuote, handleCreateSimilar, roles } =
    useContext(DealContext);

  const handleOnToggle = open => {
    setAddToggleOpen(open);
  };

  return (
    <div className="add-tab">
      <Dropdown onToggle={handleOnToggle}>
        <Dropdown.Toggle as={AddToggle} id="dropdown-custom-components">
          <i className="fas fa-plus" />
        </Dropdown.Toggle>
        <Dropdown.Menu as={AddMenu} renderMenuOnMount={true}>
          {hasQuotes === true && <Dropdown.Divider />}
          {hasCustomer === true && (
            <>
              <Dropdown.Item eventKey="3" onClick={() => presentCustomer()}>
                {showCustomer === true && <i className="fas fa-check mr-2" style={{ color: 'var(--green-5)' }} />}
                Customer
              </Dropdown.Item>
              <Dropdown.Divider />
            </>
          )}
          <Dropdown.Item eventKey="1" onClick={handleNewQuote} disabled={!roles.isSalesPerson && !roles.isSalesManager}>
            {hasQuotes === false && <i className="fas fa-star" style={{ color: 'var(--blue-5)' }} />} Create New Quote
          </Dropdown.Item>
          <Dropdown.Item eventKey="2" onClick={handleNewNote}>
            Create New Note
          </Dropdown.Item>
          {viewingQuote === true && (
            <Dropdown.Item eventKey="3" onClick={handleCopyQuote}>
              Copy This Quote
            </Dropdown.Item>
          )}
          {viewingQuote === true && (
            <Dropdown.Item eventKey="3" onClick={handleCreateSimilar}>
              Create Simliar Quote
            </Dropdown.Item>
          )}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default AddTab;
